import { InjectionToken } from "@angular/core";

/**
 * The environment injection token.
 */
export const ENVIRONMENT = new InjectionToken<BaseEnvironment>('ENVIRONMENT');

export class BaseEnvironment {
    idpServerUrl: string;
    serverUrl: string;
    loginClientId: string;
    defaultLanguage: LocaleLanguage;
    supportedLanguages: LocaleLanguage[];
    applicationName: string;
}

export class LocaleLanguage {
    locale: string;
    name: string;
}